import { useLazyQuery } from '@apollo/client';
import { T1, ALL_MODULES, Loader, getTranslatedText } from '@nile/components';
import { GET_FIELD, AccountClient } from '@nile/graphql';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Button, ButtonGroup, RadioButton } from '@shopify/polaris';
import { Popover, TextStyle, Tippy } from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import React, { useCallback, useState, useEffect } from 'react';
import { isEmpty, isEqual } from 'lodash';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { getCellValue } from '@nile/reports/src/modules/EfficiencyReport/util';
const CustomField = styled.div`
  min-width: 200px;
  max-width: 250px;
  flex-grow: 1;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  .Polaris-ButtonGroup {
    margin-top: 12px;
  }
`;
const Label = styled.div`
  text-align: left;
  font-weight: 500 !important;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 10px;
`;
const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
`;
const EditIcon = styled(Edit)`
  color: black;
  height: 16px;
  width: 16px;
  margin-left: 6px;
  margin-right: 6px;
`;
const CField = styled.div`
  .editable-cell,
  .cell {
    flex-grow: 1;
    font-weight: bold;
  }
  &:hover {
    .edit-actions {
      visibility: visible;
    }
  }
`;
const LoaderStyles = styled.div`
  padding: 40px;
`;
function AsyncRadioV2(props) {
  const {
    field,
    ticket,
    defaultValue,
    updateSelection,
    editable,
    value,
    inlineEdit,
    disableSelection,
    isMandatory,
    parentField
  } = props;

  const intl = useIntl();

  const [getFieldData, { called, loading, data }] = useLazyQuery(GET_FIELD, {
    client: AccountClient,
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        columnName: field.columnName || field.name,
        module: props.module || ALL_MODULES.ticket
      }
    }
  });
  const updateSelectedField = (checked, newValue) => {
    updateSelection(newValue);
  };

  const [radioOptions, setRadioOptions] = useState([]);
  const [popoverActive, setPopoverActive] = useState(false);

  const togglePopoverActive = useCallback(() => {
    getFieldData();
    setPopoverActive(!popoverActive);
  });
  const [updatedValue, setUpdatedValue] = useState(value || '');
  useEffect(() => {
    if (!isEqual(updatedValue, value)) {
      setUpdatedValue(value);
    }
  }, [value]);
  const updateUpdatedValue = (val) => {
    setUpdatedValue(val);
  };

  const getOptionsData = () => {
    let fieldOpts = data?.getField?.options || data?.getField?.fieldOptions;
    if (field?.isDependent) {
      const parentValue =
        getCellValue(
          ticket,
          parentField?.isCustom
            ? `customFields.${field?.nestedTo}`
            : field?.nestedTo
        ) || null;
      const prntValue =
        typeof parentValue === 'object'
          ? parentValue?.name || parentValue?.id
          : parentValue;
      if (prntValue) {
        fieldOpts = fieldOpts?.filter(
          (el) => el?.parentOption?.value === prntValue
        );
      } else {
        fieldOpts = [];
      }
    }
    setRadioOptions(fieldOpts);
  };
  const displayVal = value;
  const activator = <EditIcon onClick={() => togglePopoverActive()} />;

  useEffect(() => {
    getOptionsData();
  }, [ticket, field, data]);

  const getTag = () => {
    return (
      <CustomField className={`cf-wrapper `}>
        <Label className="cf-label">
          {field.label || ''}{' '}
          {isMandatory && (
            <>
              <span className="mandatory-star">*</span>
            </>
          )}
        </Label>
        <div
          className={`flex col ${props.error ? 'cf-error-state' : ''}`}
          key={field.name}
        >
          {radioOptions?.map((item) => {
            return (
              <RadioButton
                disabled={disableSelection}
                label={item?.value}
                id={`radio-${item?.value}-${data?.getField?.columnName ||
                  data?.getField?.name}`}
                name={`radio-${item?.value}-${data?.getField?.columnName ||
                  data?.getField?.name}`}
                checked={updatedValue === item?.value}
                onChange={() => updateUpdatedValue(item?.value)}
              />
            );
          })}
        </div>
        <ButtonGroup className="mt10">
          <Button
            onClick={() => {
              togglePopoverActive();
              setUpdatedValue('');
            }}
          >
            Cancel
          </Button>
          <Button
            primary
            onClick={() => {
              updateSelectedField('', updatedValue);
              togglePopoverActive();
            }}
            disabled={disableSelection}
          >
            Save
          </Button>
        </ButtonGroup>
      </CustomField>
    );
  };
  if (inlineEdit) {
    return !popoverActive ? (
      <CField>
        <Wrap className={`${editable ? 'editable-cell' : 'cell'}`}>
          <Tippy
            title={
              !editable && parentField
                ? getTranslatedText(
                    intl,
                    'common.ticket.field.dependant.title',
                    { name: parentField?.label }
                  )
                : undefined
            }
            duration={250}
            delay={10}
            placement="bottom-start"
            arrow={false}
            theme="dark"
            appendTo={document.body}
            className="ellipsis"
          >
            <div className="ellipsis" title={displayVal}>
              {displayVal || <DisabledTag>NA</DisabledTag>}
            </div>
          </Tippy>
          {editable && <div className="edit-actions">{activator}</div>}
        </Wrap>
      </CField>
    ) : (
      <CField>
        <Wrap className="editable-cell">
          <div className="ellipsis" title={displayVal}>
            {displayVal || <DisabledTag>NA</DisabledTag>}
          </div>
          <Popover
            activator={activator}
            active={popoverActive}
            onClose={() => {
              // togglePopoverActive()
            }}
          >
            {loading ? (
              <LoaderStyles>
                <Loader />
              </LoaderStyles>
            ) : (
              getTag()
            )}
          </Popover>
        </Wrap>
      </CField>
    );
  }
  return (
    <CustomField className="cf-wrapper">
      <Label className="cf-label">
        {field.label || ''}
        {isMandatory && (
          <>
            <span className="mandatory-star">*</span>
          </>
        )}
      </Label>
      <div
        className={`flex col ${props.error ? 'cf-error-state' : ''}`}
        key={field.name}
      >
        {radioOptions?.map((item) => {
          return (
            <RadioButton
              label={item?.value}
              id={`radio-${item?.value}-${data?.getField?.columnName}`}
              name={`radio-${item?.value}-${data?.getField?.columnName}`}
              checked={value === item?.value}
              onChange={() => updateSelection(item?.value)}
              disabled={disableSelection}
            />
          );
        })}
        {disableSelect && (
          <div className="overflow-wrap-any">
            <TextStyle variation="negative">
              {getTranslatedText(
                intl,
                'common.admin.depedant.field.choose.parent'
              )}
            </TextStyle>
          </div>
        )}
      </div>
    </CustomField>
  );
}
export default AsyncRadioV2;
